import { Component, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { OrderSettingsDcItemModel } from 'app/orders/settings-dc/settings-dc.model';
import {PersonalizedLocalStorageService} from 'app/notifications/personalized-local-storage.service';

@Component({
    selector: 'order-settings-dc',
    templateUrl: './settings-dc.component.html',
    styleUrls: ['./settings-dc.component.scss']
})
export class OrderSettingsDcComponent implements AfterContentInit {
    settings: OrderSettingsDcItemModel[] = [];
    item: OrderSettingsDcItemModel = {
        value: '', name: '', errorValue: false
    };

    @Output()
    outputSettingsDc = new EventEmitter();

    constructor(private _personalizedLocalStorageService: PersonalizedLocalStorageService) {}

    ngAfterContentInit(): void {
      this.setItems();
    }

    sendOutputSettingsDc(i: number = 0): void {
        if (this.settings[i].name !== '' && this.settings[i].errorValue) {
          this.settings[i].errorValue = false;
        }
        this.outputSettingsDc.emit(this.settings);
    }

    deleteTooltip(_i: number): string {
        return this.canDelete() ? '' : 'Last item can not be deleted.';
    }

    delete(i: number): void {
        if (this.canDelete()) {
            this.settings.splice(i, 1);
            this.sendOutputSettingsDc();
        }
    }

    canDelete(): boolean {
        return this.settings.length > 1
    }

    addItem(): void {
        this.settings.push(Object.assign({}, this.item));
    }

    setItems(): void {
        const taskPropertiesLocalStorage = this._personalizedLocalStorageService.getJson('order_properties');
        if (taskPropertiesLocalStorage && taskPropertiesLocalStorage.length > 0) {
          this.settings = Object.assign([], taskPropertiesLocalStorage);
          this.sendOutputSettingsDc();
        } else {
            this.settings = [];
            this.settings.push(Object.assign({}, this.item));
        }
    }
}
